// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eatbZsCz7Nd4VsXgh_n7 {
  position: relative;
}

.t8hMosNapZ1Mw0ijuQrB {
  display: none;
  position: absolute;
  margin-top: 0.75rem;
  border-radius: 0.25rem;
  background-color: var(--white);
  border: 0.0625rem solid var(--grey-200);
  font-size: 0.9375rem;
  line-height: 1.5rem;
  padding: 0.5rem 0;
  max-height: 15.625rem;
  overflow: auto;
  max-width: 100%;
  width: 100%;
  box-shadow: 0 0.125rem 0.25rem 0 var(--black-012);
  cursor: pointer;
  z-index: 2;
}

.n964Y0UqqTsCruvK3jLZ {
  display: block;
}

.DfwOL65UgpdCglL3UwHN {
  width: 100%;
  height: 4rem;
  background: var(--white);
  border: 0.0625rem solid var(--grey-200);
  border-radius: 0.25rem;
  line-height: 4rem;
  color: var(--denim);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.zIGS67L690S72VTzKeiy {
  line-height: inherit;
  color: inherit;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 0 1.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.DzTd0LbZ3EsOocLlZ3od {
  border: 0;
  width: 100%;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  background: transparent;
  z-index: 1;
  padding: 0 3.125rem 0 1.25rem;
}

.s1B0MuRNZjOcTepeHvNw {
  margin-left: 0.5rem;
  position: absolute;
  right: 1.25rem;
  top: 50%;
  transform: translate(0, -50%);
}

.asKKNf4p4ciDMwPOAAiE {
  transform: translate(0, -50%) rotate(180deg);
}

.nECgGdXOspUrQWHjzwkg {
  pointer-events: none
}

.nECgGdXOspUrQWHjzwkg .zIGS67L690S72VTzKeiy {
    color: var(--gray-200);
  }

.nECgGdXOspUrQWHjzwkg .Nfr2oSePKoMsWWPXMvvQ > *:first-child {
      opacity: 0.8;
    }

.nECgGdXOspUrQWHjzwkg .s1B0MuRNZjOcTepeHvNw path {
    fill: var(--gray-200);
  }

.Eeg7upYHMCr4GYRn8gWi {
  opacity: 0;
  visibility: hidden;
  position: absolute;
}

.VaIELsaFzrkZK6t6wroP {
  visibility: visible;
  cursor: default;
}

.Etx4BWVZiuIhaT_XH9ku {
  display: block;
  margin-bottom: 1rem;
  white-space: nowrap;
}

.KpdPbWLW1FnsoYWjT9VP {
  white-space: unset;
  -webkit-hyphens: auto;
          hyphens: auto;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/Select/Select.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAgB;EAChB,sBAAkB;EAClB,8BAA8B;EAC9B,uCAAiC;EACjC,oBAAe;EACf,mBAAiB;EACjB,iBAAc;EACd,qBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,iDAAiD;EACjD,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,uCAAiC;EACjC,sBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,6BAAsB;AACxB;;AAEA;EACE,mBAAgB;EAChB,kBAAkB;EAClB,cAAW;EACX,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;AAeF;;AAbE;IACE,sBAAsB;EACxB;;AAGE;MACE,YAAY;IACd;;AAGF;IACE,qBAAqB;EACvB;;AAGF;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAa;UAAb,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".select {\n  position: relative;\n}\n\n.selectList {\n  display: none;\n  position: absolute;\n  margin-top: 12px;\n  border-radius: 4px;\n  background-color: var(--white);\n  border: 1px solid var(--grey-200);\n  font-size: 15px;\n  line-height: 24px;\n  padding: 8px 0;\n  max-height: 250px;\n  overflow: auto;\n  max-width: 100%;\n  width: 100%;\n  box-shadow: 0 0.125rem 0.25rem 0 var(--black-012);\n  cursor: pointer;\n  z-index: 2;\n}\n\n.selectListOpened {\n  display: block;\n}\n\n.selectHeader {\n  width: 100%;\n  height: 64px;\n  background: var(--white);\n  border: 1px solid var(--grey-200);\n  border-radius: 4px;\n  line-height: 64px;\n  color: var(--denim);\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.selectHeaderValue {\n  line-height: inherit;\n  color: inherit;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  padding: 0 24px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.selectInput {\n  border: 0;\n  width: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  background: transparent;\n  z-index: 1;\n  padding: 0 50px 0 20px;\n}\n\n.chevron {\n  margin-left: 8px;\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translate(0, -50%);\n}\n\n.chevronUp {\n  transform: translate(0, -50%) rotate(180deg);\n}\n\n.disabled {\n  pointer-events: none;\n\n  & .selectHeaderValue {\n    color: var(--gray-200);\n  }\n\n  & .selectHeaderValueWithIcon {\n    & > *:first-child {\n      opacity: 0.8;\n    }\n  }\n\n  & .chevron path {\n    fill: var(--gray-200);\n  }\n}\n\n.noSearchableInputDefaultState {\n  opacity: 0;\n  visibility: hidden;\n  position: absolute;\n}\n\n.noSearchableInputOpenedListState {\n  visibility: visible;\n  cursor: default;\n}\n\n.selectLabel {\n  display: block;\n  margin-bottom: 16px;\n  white-space: nowrap;\n}\n\n.noWrap {\n  white-space: unset;\n  hyphens: auto;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `eatbZsCz7Nd4VsXgh_n7`,
	"selectList": `t8hMosNapZ1Mw0ijuQrB`,
	"selectListOpened": `n964Y0UqqTsCruvK3jLZ`,
	"selectHeader": `DfwOL65UgpdCglL3UwHN`,
	"selectHeaderValue": `zIGS67L690S72VTzKeiy`,
	"selectInput": `DzTd0LbZ3EsOocLlZ3od`,
	"chevron": `s1B0MuRNZjOcTepeHvNw`,
	"chevronUp": `asKKNf4p4ciDMwPOAAiE`,
	"disabled": `nECgGdXOspUrQWHjzwkg`,
	"selectHeaderValueWithIcon": `Nfr2oSePKoMsWWPXMvvQ`,
	"noSearchableInputDefaultState": `Eeg7upYHMCr4GYRn8gWi`,
	"noSearchableInputOpenedListState": `VaIELsaFzrkZK6t6wroP`,
	"selectLabel": `Etx4BWVZiuIhaT_XH9ku`,
	"noWrap": `KpdPbWLW1FnsoYWjT9VP`
};
export default ___CSS_LOADER_EXPORT___;
